import { SetStateAction } from "react";
import { SecondaryColor, NeutralColor } from "node-library/dist/colors";
import React from "react";

interface StepsBarProps {
	items: Array<string>;
	currentItem: number;
	setCurrentItem: React.Dispatch<SetStateAction<number>>;
	icons: Array<JSX.Element>;
}

function StepsBar(props: StepsBarProps): JSX.Element {
	const { items, currentItem, icons, setCurrentItem } = props;

	const content: Array<React.ReactNode> = items.map((text, index) => {
		return (
			<React.Fragment key={index}>
				{index !== 0 && (
					<hr
						className="step-bar-line"
						style={{
							width: 100 / (items.length * 2 - 1) + "%",
							color: NeutralColor.NEUTRAL_GREY_200,
						}}
					></hr>
				)}
				<div
					className="step-bar-item typography-body-02"
					style={{
						display: "flex",
						alignItems: "center",
						color:
							index === currentItem
								? SecondaryColor.SECONDARY_900
								: NeutralColor.NEUTRAL_GREY_200,
						gap: "10px",
						minWidth: "max-content",
						padding: "8px 16px 8px 14px",
						transition: "color 0.3s ease",
					}}
				>
					{icons[index]}
					<div className="typography-body-01">{text}</div>
				</div>
			</React.Fragment>
		);
	});

	return <div className="step-bar">{content}</div>;
}

export { StepsBar };
